export default __webpack_public_path__ + "static/media/IMG_0702 copie.9f837722.jpg";